import _Number$parseInt from "@babel/runtime-corejs3/core-js-stable/number/parse-int";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Contains the selectors that select state from the 'UASystemConfiguration' store object.
 * @namespace SystemConfigurationSelectors
 */

var selectors = function selectors() {
  _classCallCheck(this, selectors);
};

_defineProperty(selectors, "moduleIdentifier", 'UASystemConfiguration');

_defineProperty(selectors, "getSystemConfiguration", function (state) {
  return state[selectors.moduleIdentifier].systemConfiguration.payload;
});

_defineProperty(selectors, "getValue", function (state, key) {
  var systemProperties = state[selectors.moduleIdentifier].systemConfiguration.payload;

  if (_Array$isArray(systemProperties)) {
    for (var i = 0; i < systemProperties.length; i += 1) {
      if (systemProperties[i].propertyName === key) {
        return systemProperties[i].propertyValue;
      }
    }
  }

  return null;
});

_defineProperty(selectors, "getIntegerValue", function (state, key) {
  return _Number$parseInt(selectors.getValue(state, key), 10);
});

_defineProperty(selectors, "getBooleanValue", function (state, key) {
  var value = selectors.getValue(state, key);

  if (value && (value === true || value === 'true' || value.toLowerCase() === 'yes')) {
    return true;
  }

  if (value && (value === 'false' || value.toLowerCase() === 'no')) {
    return false;
  }

  return null;
});

_defineProperty(selectors, "isFetchingSystemConfiguration", function (state) {
  return state[selectors.moduleIdentifier].isFetchingSystemConfiguration.payload;
});

_defineProperty(selectors, "systemConfigurationError", function (state) {
  return state[selectors.moduleIdentifier].systemConfigurationError.payload;
});

export { selectors as default };